import { render } from "./Netpay-index.vue?vue&type=template&id=16704ce4"
import script from "./Netpay-index.vue?vue&type=script&lang=js"
export * from "./Netpay-index.vue?vue&type=script&lang=js"

import "./Netpay-index.vue?vue&type=style&index=0&id=16704ce4&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__